// import { useSelector } from "react-redux";
import { Grid, Typography } from "@mui/material";
// import { getThemeCompareSelectedValue } from "../../../reducer/patientCompareSlice";

function SpotmapLegend(props) {
    // const themeCompare = useSelector(getThemeCompareSelectedValue);
    // const populationValue = useSelector(getPopulationRate);

    return (
        <>
            <div style={{
                position: 'relative'
            }}>
                <Typography sx={{ 
                    fontSize: 12, 
                    textAlign: 'left',
                    fontWeight: '400',
                }}>
                    ตำแหน่งผู้ป่วย
                </Typography>
                <Grid container spacing={0}>
                
                    <Grid container item xs={6}>
                        <Grid item xs={1} sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'right'
                        }}>
                            <div style={{
                                height: '5px',
                                width: '5px',
                                marginTop: '5px',
                                backgroundColor: '#D92405',
                                borderColor: '#D92405',
                                borderRadius: '50px'
                            }}></div>
                        </Grid>
                        <Grid item xs={11} >
                            <Typography sx={{
                                fontSize: 10,
                                textAlign: 'center',
                                marginTop: '5px',
                                fontWeight: '400',
                            }}>
                                ตำแหน่งสุ่ม ≤ 15 ปี
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container item xs={6}>
                        <Grid item xs={1} sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'right'
                        }}>
                            <div style={{
                                height: '5px',
                                width: '5px',
                                marginTop: '5px',
                                backgroundColor: '#0c2271',
                                borderColor: '#0c2271',
                                borderRadius: '50px'
                            }}></div>
                        </Grid>
                        <Grid item xs={11}>
                            <Typography sx={{
                                fontSize: 10,
                                textAlign: 'center',
                                marginTop: '5px',
                                fontWeight: '400',
                            }}>
                                ตำแหน่งสุ่ม &gt; 15 ปี
                            </Typography>
                        </Grid>
                    </Grid>
                    {/* // themeCompare.map((data, index) => {
                    //     return (
                    //         <Grid key={index} item xs={(12/themeCompare.length)}>
                    //             <div style={{
                    //                 height: 20,
                    //                 backgroundColor: data.color,
                    //                 marginTop: '5px'
                    //             }}></div>
                    //             <Typography sx={{
                    //                 fontSize: 10,
                    //                 textAlign: 'center',
                    //                 marginTop: '5px'
                    //             }}>
                    //                 {data.legend}
                    //             </Typography>
                    //         </Grid>
                    //     )
                    // }) */}
                </Grid>
            </div>
        </>
    )
}

export default SpotmapLegend;